/**
 * PostHog analytics — cookie-less mode for GDPR compliance
 *
 * @see Issue #80
 */
import posthog from "posthog-js";
import { createLogger } from '@/lib/logger';

const log = createLogger('PostHog');
let initialized = false;

export function initPostHog(): void {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST;
  if (!key || !host || initialized) return;

  posthog.init(key, {
    api_host: host,
    persistence: "memory", // cookie-less
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
  });
  initialized = true;
  log.info('Initialized', { host });
}

/* ── Event catalog ── */
export const PostHogEvents = {
  USER_LOGGED_IN: "user_logged_in",
  USER_REGISTERED: "user_registered",
  USER_LOGGED_OUT: "user_logged_out",
  ATOM_VIEWED: "atom_viewed",
  TOPIC_VIEWED: "topic_viewed",
  MUSING_CREATED: "musing_created",
  REPOST_CREATED: "repost_created",
  SEARCH_PERFORMED: "search_performed",
  EXTRACT_STARTED: "extract_started",
  EXTRACT_COMPLETED: "extract_completed",
} as const;

export function trackEvent(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  log.debug('Event tracked', { event, ...properties });
  posthog.capture(event, properties);
}

export function identifyUser(userId: string, traits?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.identify(userId, traits);
}

export function resetIdentity(): void {
  if (!initialized) return;
  posthog.reset();
}

export function trackPageView(url: string): void {
  if (!initialized) return;
  posthog.capture("$pageview", { $current_url: url });
}